import { Box } from '@factorialco/deprecated-design-system'

import { WorkedTimeData } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/lib/calculateWorkedTime'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import { SidePanelTab } from 'modules/attendance/lib/sidepanelTabTypes'
import { DailyBalanceAggregateType } from 'modules/attendance/lib/utils/Balance'

import AgreementHours from './AgreementHours'
import PlannedHours from './PlannedHours'
import WorkedHours from './WorkedHours'

interface Props {
  contractHoursBaselineEnabled: boolean
  dailyBalanceAggregate: DailyBalanceAggregateType
  handleTabClick: (tabId: SidePanelTab) => void
  rangeIncludesToday: boolean
  workedTimeData: WorkedTimeData
  adjustedDailyMinutes?: number | null
}

const BankOfHoursCounters = ({
  contractHoursBaselineEnabled,
  dailyBalanceAggregate,
  handleTabClick,
  rangeIncludesToday,
  workedTimeData,
  adjustedDailyMinutes,
}: Props) => {
  const {
    minutes,
    estimatedMinutes,
    estimatedRegularMinutes,
    estimatedOvertimeMinutes,
    contractMinutes: contractMinutesToDate,
    contractMinutesEndOfPeriod,
    absencesMinutes,
  } = workedTimeData
  const { balanceFromPlanning, balanceFromContract } = dailyBalanceAggregate
  const { cycle } = useAttendanceDateNavigator()

  // Hide AgreementHours in monthly view when adjustedDailyMinutes is present
  const isMonthlyWithAdjustedMinutes = cycle === 'monthly' && adjustedDailyMinutes != null

  const shouldDisplayAgreementHours = contractHoursBaselineEnabled && !isMonthlyWithAdjustedMinutes

  const contractMinutes = adjustedDailyMinutes ? contractMinutesEndOfPeriod : contractMinutesToDate

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      padding="s16"
      gap="s16"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      width="full"
      gapDivider
      cursor="pointer"
      onClick={() => handleTabClick('worked_hours')}
    >
      <WorkedHours
        minutes={minutes}
        paidAbsencesMinutes={absencesMinutes}
        rangeIncludesToday={rangeIncludesToday}
        contractHoursBaselineEnabled={contractHoursBaselineEnabled}
      />
      <PlannedHours
        estimatedMinutes={estimatedMinutes}
        estimatedRegularMinutes={estimatedRegularMinutes}
        estimatedOvertimeMinutes={estimatedOvertimeMinutes}
        rangeIncludesToday={rangeIncludesToday}
        balanceFromPlanning={balanceFromPlanning}
      />
      {shouldDisplayAgreementHours && (
        <AgreementHours
          contractMinutes={contractMinutes}
          balanceFromContract={balanceFromContract}
          rangeIncludesToday={rangeIncludesToday}
          adjustedDailyMinutes={adjustedDailyMinutes}
        />
      )}
    </Box>
  )
}

export default BankOfHoursCounters
